export const chartColors = {
	enqueued: "#CC456D",
	onGoing: "#EBAF78",
	finished: "#50C7AC"
}
